<template>
  <page-wrapper title="รายงาน SAP PO Report (MM)">
    <div class="sap-mm-po-vender-report">
      <vue-tabs class="child-component" active-tab-color="#d3d0cf">
        <v-tab title="SAP PO Report">
					<sap-po-list></sap-po-list>
				</v-tab>
        <v-tab title="รอส่ง SAP">
          <sap-po-resend-list class="mt-4"></sap-po-resend-list>
        </v-tab>
      </vue-tabs>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import SapPoList from '../component/SapPoList';
import SapPoResendList from '../component/SapPoResendList';

export default {
  components: {
    PageWrapper,
    SapPoList,
    SapPoResendList,
  },
  data() {
return {
    tabToChange: "Second tab",
  };
},
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";


.sap-mm-po-vender-report {
  padding-left: 30px;
  padding-top: 30px;
	font-size: 20px ;
}

.child-wrapper {
  font-size: 20px;
}

.child-wrapper * {
  font-size: inherit;
}
</style>